<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.femalePercentage.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">男女別新規採用数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femalePercentage.regularMaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femalePercentage.nonRegularMaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femalePercentage.regularFemaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femalePercentage.nonRegularFemaleEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>合計</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfRegularEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularEmployee" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllEmployee" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
      <div class="human-capitalt-data-wrap__arrow"></div>
      <div class="human-capitalt-data-wrap__results is-half" style="width:50%;">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            採用女性労働者割合
            <strong><Currency :value="this.calFemalePercentage"/></strong>%
          </div>
        </div>
      </div>
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femalePercentage.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femalePercentage.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    femalePercentage: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    sumOfMaleEmployee() {
      if ( !(this.femalePercentage.regularMaleEmployee!=null && this.femalePercentage.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularMaleEmployee).length * String(this.femalePercentage.nonRegularMaleEmployee).length == 0) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularMaleEmployee) || isNaN(this.femalePercentage.nonRegularMaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularMaleEmployee) + Number(this.femalePercentage.nonRegularMaleEmployee);
      }
    },
    sumOfFemaleEmployee() {
      if ( !(this.femalePercentage.regularFemaleEmployee!=null && this.femalePercentage.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularFemaleEmployee).length * String(this.femalePercentage.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularFemaleEmployee) || isNaN(this.femalePercentage.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularFemaleEmployee) + Number(this.femalePercentage.nonRegularFemaleEmployee);
      }
    },
    sumOfRegularEmployee() {
      if ( !(this.femalePercentage.regularMaleEmployee!=null && this.femalePercentage.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.regularMaleEmployee).length * String(this.femalePercentage.regularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.regularMaleEmployee) || isNaN(this.femalePercentage.regularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.regularMaleEmployee) + Number(this.femalePercentage.regularFemaleEmployee);
      }
    },
    sumOfNonRegularEmployee() {
      if ( !(this.femalePercentage.nonRegularMaleEmployee!=null && this.femalePercentage.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.femalePercentage.nonRegularMaleEmployee).length * String(this.femalePercentage.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.femalePercentage.nonRegularMaleEmployee) || isNaN(this.femalePercentage.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.femalePercentage.nonRegularMaleEmployee) + Number(this.femalePercentage.nonRegularFemaleEmployee);
      }
    },
    sumOfAllEmployee() {
      if ( !(this.sumOfRegularEmployee!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularEmployee) + Number(this.sumOfNonRegularEmployee);
      }
    },
    calFemalePercentage() {
      if ( this.sumOfFemaleEmployee != null && this.sumOfAllEmployee != null ){
        let val = (this.sumOfFemaleEmployee / this.sumOfAllEmployee) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }
  },
  watch: {
    femalePercentage() {
      this.inputFemalePercentage();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFemalePercentage() {
      this.$emit("change-female-percentage-detail", {
        femalePercentage: this.femalePercentage,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
